import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow4",
  "use": "icon-arrow4-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow4\">\n<path d=\"M12.6716 6.9999L7.3076 1.63589L8.7218 0.22168L16.5 7.9999L8.7218 15.778L7.3076 14.3638L12.6716 8.9999H0.5V6.9999H12.6716Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol